import orderHeader from "../Header/layout.vue";
import orderPin from "@/components/order/Pin/layout.vue";
import pinControl from "@/components/order/Pin/pinControl.vue";
import deliveryOptions from "@/components/order/DeliveryOptions/layout.vue";
import deliveryItem from "@/components/order/DeliveryItem/layout.vue";
import additionalItem from "@/components/order//Additional/layout.vue";
import sideBar from "@/components/order/SideBar/layout.vue";
import mobileSidbar from "@/components/order/MobileSidbar/layout.vue";
import trunkItem from "@/components/order/TrunckItem/layout.vue";
import commonPopup from "@/components/modal/commonPopup/layout.vue";
import cartPopup from "@/components/modal/cartPopup/layout.vue";
import payment from "@/components/modal/payment/layout.vue";
import deliveryType from "@/components/order/DeliveryType/layout.vue";
import mixinOrder from "@/mixins/mixinOrder";
import mixinOrderValidate from "@/mixins/mixinOrderValidate";
import timeToast from "@/components/common/timeToast.vue";
import orderNotice from "@/components/modal/orderNotice/layout";

export default {
  mixins: [mixinOrder, mixinOrderValidate],
  metaInfo: {
    title: "주문접수"
  },
  components: {
    orderNotice,
    timeToast,
    mobileSidbar,
    orderHeader,
    orderPin,
    pinControl,
    deliveryOptions,
    deliveryItem,
    additionalItem,
    sideBar,
    trunkItem,
    commonPopup,
    cartPopup,
    payment,
    deliveryType
  },
  data() {
    return {
      openPopup: false,
      popupList: [],

      popupMsg: "",
      showPayment: false,
      isPopupOpen: false,
      isCartOpen: false,
      istimeOpen: false,

      nowStep: 1,
      stepAvailable: false,

      departureBookmarkList: [],
      destinationBookmarkList: [],

      paymentOrder: [],

      invalidPinIdx: null,
      submitItemValid: false,

      vehicles: {}
    };
  },
  async created() {
    this.$store.commit("form/resetState");
    this.checkConfig();
    await this.getVehicles();

    this.getBookmarkAddress(1);
    this.getBookmarkAddress(2);
    if (this.$route.params.flag === "reorder") {
      this.reOrder();
    }

    if (this.$route.params.flag === "update") {
      this.editOrder();
    }

    /**
     * 팝업 목록 불러오기
     */
    this.$store
      .dispatch("notice/getOrderPopup")
      .then((res) => {
        this.popupList = res.popups;
        if (!this.popupList.length) return;
        this.$store
          .dispatch("popup/checkOrder", this.popupList[0]._id)
          .then((res) => {
            if (res === "show") this.openPopup = true;
            else this.openPopup = false;
          });
      })
      .catch((e) => {});
  },

  watch: {
    getPins: {
      handler() {
        this.checkPinValidate();
      },
      deep: true
    },

    "getDeliveryOptions.isExpressDelivery": {
      handler(val) {
        if (val !== null) {
          this.handleStep(3);
        }
      }
    },

    "getDeliveryOptions.vehicleCategory": {
      handler(val) {
        if (val !== null) {
          this.handleStep(4);
        }
      }
    },

    "getDeliveryOptions.item": {
      //vehicleItemCode 1: 퀵 / 2: 화물
      handler(val) {
        if (this.getDeliveryOptions.vehicleItemCode === 1 && this.checkItem()) {
          this.handleStep(5);
        } else if (
          this.getDeliveryOptions.vehicleItemCode === 2 &&
          this.checkItem()
        ) {
          this.checkFreightOptionStep();
        }
      },
      deep: true
    },
    "getDeliveryOptions.weight": {
      handler(val) {
        if (this.getDeliveryOptions.vehicleItemCode === 1 && this.checkItem()) {
          this.handleStep(5);
        }
      },
      deep: true
    },
    "getDeliveryOptions.loadingPosition": {
      handler(val) {
        if (val === null) return;
        this.calculate();
        this.checkFreightOptionStep();
      }
    },
    "getDeliveryOptions.unloadingPosition": {
      handler(val) {
        if (val === null) return;
        this.calculate();
        this.checkFreightOptionStep();
      }
    },
    "getDeliveryOptions.loadingMethod": {
      handler(val) {
        if (val === null) return;
        this.calculate();
        this.checkFreightOptionStep();
      }
    },
    "getDeliveryOptions.unloadingMethod": {
      handler(val) {
        if (val === null) return;
        this.calculate();
        this.checkFreightOptionStep();
      }
    },

    getTimeInvalid: {
      handler(val) {
        if (val) {
          this.moveScroll("delivery-type");
        }
      }
    }
  },
  computed: {},
  methods: {
    /**
     * 화물용 handleStep
     */
    checkFreightOptionStep() {
      if (this.checkFreightOption() && !this.getItemInvalid) {
        this.handleStep(5);
      }
    },

    /**
     *
     * @param {string} id
     * 스크롤 이동
     */
    moveScroll(id) {
      const location = document.getElementById(id).offsetTop;
      const headerHeight = document.getElementById("header").offsetHeight;

      window.scrollTo({
        top: location - headerHeight,
        left: 0,
        behavior: "smooth"
      });
    },

    /**
     *
     * 접수 가능 여부 확인
     */
    async checkConfig() {
      const config = await this.$store.dispatch("api_get_config");
      if (config.closed === true) {
        return this.controlPopup("현재 주문접수가 마감되었습니다");
      }
    },

    /**
     * 운송수단 조합 조회
     */
    async getVehicles() {
      const result = await this.$store.dispatch("config/getVehicles");
      this.vehicles = result.vehicle;
    },

    closeCartPopup() {
      if (this.$route.params.flag === "update") {
        this.$router.push("/orders/form");
      }
      this.resetStep();
      this.$store.commit("form/resetState");
      this.isCartOpen = false;
      window.scrollTo(0, 0);
    },

    /**
     * 재주문 오더 데이터 가공
     */
    async reOrder() {
      const { order } = await this.$store.dispatch(
        "orders/orderDetail",
        this.$route.params.id
      );
      if (order.pins.length > 2) {
        for (let i = 0; i < order.pins.length - 2; i++) {
          this.addPin(i);
        }
      }

      let pins = [];
      for (let i = 0; i < order.pins.length; i++) {
        const pin = {
          name: order.pins[i].name,
          phoneNumber: order.pins[i].phoneNumber,
          dongName: order.pins[i].dongName,
          coords: order.pins[i].coords,
          jibunAddress: order.pins[i].jibunAddress,
          roadAddress: order.pins[i].roadAddress,
          detailAddress: order.pins[i].detailAddress,
          addToBookmark: false,
          pickupDate: order.pins[i].pickupDate,
          pickupHour: order.pins[i].pickupHour,
          pickupMinute: order.pins[i].pickupMinute,
          pinMemo: order.pins[i].pinMemo
        };
        pins.push(pin);
      }

      this.updatePins(pins); //핀정보 저장

      //배송수단
      const vehicle = order.vehicles[0];
      this.updateVehicleCategory(vehicle.vehicleCategoryCode ?? null);
      this.updateVehicleItemCode(vehicle.vehicleCategoryCode === 8 ? 2 : 1);
      this.updateVehicleType(vehicle.vehicleTypeCode ?? null);
      this.updateVehicleOptions(vehicle.vehicleOptionCode ?? null);
      this.updateLoadingPosition(vehicle.loadingPositionCode ?? null);
      this.updateUnLoadingPosition(vehicle.unloadingPositionCode ?? null);
      this.updateLoadingMethod(vehicle.loadingMethodCode ?? null);
      this.updateUnLoadingMethod(vehicle.unloadingMethodCode ?? null);

      if (order.isReserved !== undefined) {
        //예약여부
        // 이전버전 사용자 대비
        this.updateIsReserved(order.isReserved);
      } else {
        this.updateIsReserved(true);
      }

      //급송여부
      if (order.isExpressDelivery !== undefined) {
        this.updateIsExpressDelivery(order.isExpressDelivery);
      }

      this.updateClientComment(order.clientComment);
      this.updateWeight(order.item["weight"]);

      if (order.item["etc"] !== null) {
        this.updateItemEtc(true, order.item["etc"]);
      } else {
        this.updateItemEtc(false, null);
      }

      //오더상세 데이터 -> 2.0form 으로 데이터 가공
      for (const [key, value] of Object.entries(order.item)) {
        if (key !== "fragile" && key !== "weight" && key !== "etc") {
          if (value !== 0 && key !== "fragile") {
            this.updateItem(key, value, true);
          }
        }
      }
      this.calculate();
    },

    /**
     *
     * 수정하는 오더 데이터 가공
     */
    editOrder() {
      const placedOrder = _.cloneDeep(
        this.$store.getters["returnPlacedOrder"]()
      );

      const editData = _.cloneDeep(placedOrder[this.$route.params.id]);
      if (editData === undefined) {
        this.$router.push("/orders/form");
        return this.controlPopup("해당 주문이 존재하지 않습니다.");
      }
      if (editData.pins.length > 2) {
        for (let i = 0; i < editData.pins.length - 2; i++) {
          this.addPin(i);
        }
      }

      this.updatePins(editData.pins);
      this.updateDeliveryOptions(editData.deliveryOptions);
      this.calculate();
    },

    /**
     *
     * 주소카드에서 즐겨찾기 주소 삭제
     */
    async deleteAddress(list, code) {
      const bookmarkId = list.bookmarkId ? list.bookmarkId : list._id;
      const result = await this.$store
        .dispatch("users/biz_delete_bookmark", { bookmarkId: bookmarkId })
        .then((result) => {
          if (!result.success) {
            this.controlPopup("에러가 발생하였습니다.");
          }
          this.getBookmarkAddress(code);
        })
        .catch((e) => {
          console.error(e);
          this.controlPopup("에러가 발생하였습니다.");

          this.getBookmarkAddress(code);
          this.controlPopup("에러가 발생하였습니다");
        });
    },

    /**
     *
     * @param {number} code
     * 주소지 카드에서 노출 할 즐겨찾기 주소 불러오기
     */
    async getBookmarkAddress(code) {
      let addrResult = [];
      const payload = {
        code: code,
        keyword: ""
      };

      const result = await this.$store.dispatch(
        "users/getBookmarkAddress",
        payload
      );
      addrResult = result.bookmarkAddress;

      if (code === 1) {
        this.departureBookmarkList = [];
        for (let i = 0; i < Math.min(4, addrResult.length); i++) {
          this.departureBookmarkList.push(addrResult[i]);
        }
      }

      if (code === 2) {
        this.destinationBookmarkList = [];
        for (let i = 0; i < Math.min(4, addrResult.length); i++) {
          this.destinationBookmarkList.push(addrResult[i]);
        }
      }
    },

    /**
     *
     * 바로주문 클릭시 유효성 검증 후 결제모달 노출
     */
    openPayment() {
      this.paymentOrder = [];
      if (this.getLoadingStatus) return;
      if (this.getDeliveryOptions.isReserved && !this.checkPickupTime()) return;
      if (!this.checkValidateBeforeSubmit()) return;
      this.setDataForPayment();
      this.showPayment = true;
    },

    /**
     *
     * 장바구니에 저장
     */
    async placeOrder() {
      if (this.getLoadingStatus) return;

      if (this.getDeliveryOptions.isReserved && !this.checkPickupTime()) return;
      if (!this.checkValidateBeforeSubmit()) return;

      // 장바구니에에 추가
      try {
        if (this.$route.params.id) {
          const order = _.cloneDeep(this.$store.getters["returnPlacedOrder"]());
          order.splice(this.$route.params.id, 1);
          this.$store.commit("replaceTemporaryOrders", order);
        }
        const calcUuid = this.getDeliveryOptions.calcUuid;

        this.$store.commit("pushTemporaryOrders", {
          pins: this.getPins,
          calcUuid: calcUuid,
          deliveryOptions: this.getDeliveryOptions,
          checked: false
        });
      } catch (error) {
        console.error(error);
        return this.controlPopup("주문추가 중 오류가 발생하였습니다");
      }
      this.isCartOpen = true;
    },

    /**
     *
     * 장바구니 저장, 바로 주문 전 유효성 검증, 스크롤 이동
     */
    checkValidateBeforeSubmit() {
      //pin별 validation
      for (let i = 0; i < this.getPins.length; i++) {
        if (
          !this.getPins[i].name ||
          !this.getPins[i].coords ||
          !this.getPins[i].phoneNumber
        ) {
          this.moveScroll(`pin-${i}`);
          this.invalidPinIdx = i;
          return false;
        }
      }

      //물품종류 확인
      if (!this.checkItemvalidate()) {
        this.moveScroll("delivery-item");
        this.submitItemValid = true;
        this.controlPopup(
          this.getDeliveryOptions.vehicleItemCode === 1
            ? "물품종류를 선택해주세요"
            : "물품에 대해 입력해 주세요."
        );
        return false;
      }

      //물품 무게 확인
      if (this.getDeliveryOptions.weight <= 0) {
        this.moveScroll("delivery-item");
        this.submitItemValid = true;
        this.controlPopup("물품의 무게를 선택해주세요");
        return false;
      }

      if (
        this.getDeliveryOptions.vehicleItemCode === 2 &&
        !this.checkFreightOption()
      ) {
        this.moveScroll("delivery-item");
        this.submitItemValid = true;
        this.controlPopup("상하차 정보를 선택해주세요");
        return false;
      }

      return true;
    },

    /**
     *
     * 바로주문 클릭시 데이터가공
     */
    setDataForPayment() {
      try {
        const calcUuid = this.getDeliveryOptions.calcUuid;
        this.paymentOrder = [
          {
            pins: this.getPins,
            calcUuid: calcUuid,
            deliveryOptions: this.getDeliveryOptions,
            checked: true
          }
        ];
      } catch (error) {
        console.error(error);
        return this.controlPopup("주문추가 중 오류가 발생하였습니다");
      }
    },

    controlPopup(msg) {
      this.popupMsg = msg;
      this.isPopupOpen = true;
    }
  }
};
